import { render, staticRenderFns } from "./WhySection.vue?vue&type=template&id=7b51749a&scoped=true&"
import script from "./WhySection.vue?vue&type=script&lang=js&"
export * from "./WhySection.vue?vue&type=script&lang=js&"
import style0 from "./WhySection.vue?vue&type=style&index=0&id=7b51749a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51749a",
  null
  
)

/* custom blocks */
import block0 from "./WhySection.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports